import {getTextureCanvasList, pushNullToTextureCanvasList} from './dataOps';
import {getMainCanvasDOMElement} from './mainCanvasDOM';

declare global {
  // eslint-disable-next-line no-var -- NOTE: TypeScriptのグローバルスコープ拡張では「var」が必須
  var g_WebglContext: WebGLRenderingContext | undefined;
}

/**
 * WebGLContext (GET)
 * @returns
 */
export const getWebGLRenderingContext = (): WebGLRenderingContext | undefined => {
  return globalThis.g_WebglContext;
};
/**
 * WebGLContext (SET)
 * @param webglContext WebGLRenderingContext型
 */
export const setWebGLRenderingContext = (webglContext: WebGLRenderingContext) => {
  Object.assign(globalThis, {g_WebglContext: webglContext});
};

/**
 * Video (GET)
 * @returns HTMLVideoElement|undefined
 */
export const getVideo = (): HTMLVideoElement | undefined => {
  if (globalThis.g_Video === undefined || globalThis.g_Video === null) {
    return undefined;
  }
  return globalThis.g_Video;
};

/**
 * Video(SET)
 * @param video HTMLVideoElement | Null
 */
export const setVideo = (video: HTMLVideoElement | null) => {
  globalThis.g_Video = video;
};

/**
 * InputFileDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getInputFileDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_InputFile === undefined || globalThis.g_InputFile === null) {
    return undefined;
  }
  return globalThis.g_InputFile;
};

/**
 * InputFileDOMElement (SET)
 * @remarks
 * 未使用
 * @param inputFile HTMLElement型
 */
export const setInputFileDOMElement = (inputFile: HTMLElement) => {
  if (inputFile === undefined || inputFile === null) {
    return;
  }
  globalThis.g_InputFile = inputFile;
};

/**
 * ConfigUrlDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getConfigUrlDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_configurl === undefined || globalThis.g_configurl === null) {
    return undefined;
  }
  return globalThis.g_configurl;
};

/**
 * ConfigUrlDOMElement (SET)
 * @remarks
 * 未使用
 * @param configUrl HTMLElement型
 */
export const setConfigUrlDOMElement = (configUrl: HTMLElement) => {
  if (configUrl === undefined || configUrl === null) {
    return;
  }
  globalThis.g_configurl = configUrl;
};

/**
 * LocalTextConfigUrlDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getLocalTextConfigUrlDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_localText_configurl === undefined || globalThis.g_localText_configurl === null) {
    return undefined;
  }
  return globalThis.g_localText_configurl;
};

/**
 * LocalTextConfigUrlDOMElement (SET)
 * @remarks
 * 未使用
 * @param localTextConfigUrl HTMLElement型
 */
export const setLocalTextConfigUrlDOMElement = (localTextConfigUrl: HTMLElement) => {
  if (localTextConfigUrl === undefined || localTextConfigUrl === null) {
    return;
  }
  globalThis.g_localText_configurl = localTextConfigUrl;
};

/**
 * UserNameDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getUserNameDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_username === undefined || globalThis.g_username === null) {
    return undefined;
  }
  return globalThis.g_username;
};

/**
 * UserNameDOMElement (SET)
 * @remarks
 * 未使用
 * @param userName HTMLElement型
 */
export const setUserNameDOMElement = (userName: HTMLElement) => {
  if (userName === undefined || userName === null) {
    return;
  }
  globalThis.g_username = userName;
};

/**
 * LocalTextUserNameDOMElement (GET)
 * @returns
 */
export const getLocalTextUserNameDOMElement = (): HTMLInputElement | undefined => {
  return globalThis.g_localText_username ?? undefined;
};

/**
 * SkywayMsgDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getSkywayMsgDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_skyway_msg === undefined || globalThis.g_skyway_msg === null) {
    return undefined;
  }
  return globalThis.g_skyway_msg;
};

/**
 * SkywayMsgDOMElement (SET)
 * @remarks
 * 未使用
 * @param skywayMsg HTMLElement型
 */
export const setSkywayMsgDOMElement = (skywayMsg: HTMLElement) => {
  if (skywayMsg === undefined || skywayMsg === null) {
    return;
  }
  globalThis.g_skyway_msg = skywayMsg;
};

/**
 * SkywayLocalTextDOMElement (GET)
 * @returns
 */
export const getSkywayLocalTextDOMElement = (): HTMLInputElement | undefined => {
  return globalThis.g_skyway_localText ?? undefined;
};

/**
 * StatusDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getStatusDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_Status === undefined || globalThis.g_Status === null) {
    return undefined;
  }
  return globalThis.g_Status;
};

/**
 * StatusDOMElement (SET)
 * @remarks
 * 未使用
 * @param status HTMLElement型
 */
export const setStatusDOMElement = (status: HTMLElement) => {
  if (status === undefined || status === null) {
    return;
  }
  globalThis.g_Status = status;
};

/**
 * LogDOMElement (GET)
 * @returns HTMLElement|undefined
 */
export const getLogDOMElement = (): HTMLElement | undefined => {
  if (globalThis.g_Log === undefined || globalThis.g_Log === null) {
    return undefined;
  }
  return globalThis.g_Log;
};

/**
 * LogDOMElement (SET)
 * @remarks
 * 未使用
 * @param status HTMLElement型
 */
export const setLogDOMElement = (status: HTMLElement) => {
  if (status === undefined || status === null) {
    return;
  }
  globalThis.g_Log = status;
};

/**
 * @remarks
 * 次のキャンバスインデックス番号を取得
 */
export const defineNextTextCanvasIndex = (): number => {
  const canvasList = getTextureCanvasList();
  for (let index = 0; index < canvasList.length; index++) {
    if (canvasList[index] === null) {
      return index;
    }
  }

  pushNullToTextureCanvasList();
  return canvasList.length - 1;
};

/**
 * 未使用
 */
export const hel_InputFileClick = () => {
  const inputFile = getInputFileDOMElement();
  if (inputFile !== undefined) {
    inputFile.click();
  }
};

/**
 * 未使用
 */
export const hel_toggleFullScreen = async () => {
  const mainCanvas = getMainCanvasDOMElement();
  if (!document.fullscreenEnabled || mainCanvas === undefined) {
    return;
  }

  if (!document.fullscreenElement) {
    await mainCanvas.requestFullscreen();
  } else {
    await document.exitFullscreen();
  }
};

/**
 * 未使用
 */
export const hel_backToTitle = () => {
  window.location.reload();
};
